import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.tooltip = document.createElement("div")
    this.tooltip.className =
      "pointer-events-none fixed z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded shadow-lg opacity-0 transition-opacity duration-150 whitespace-nowrap"
    document.body.appendChild(this.tooltip)

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.element.addEventListener("mouseover", this.show)
    this.element.addEventListener("mouseout", this.hide)
    this.element.addEventListener("focusin", this.show)
    this.element.addEventListener("focusout", this.hide)
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this.show)
    this.element.removeEventListener("mouseout", this.hide)
    this.element.removeEventListener("focusin", this.show)
    this.element.removeEventListener("focusout", this.hide)
    this.tooltip.remove()
  }

  show(event) {
    const target = event.target.closest("[data-tooltip-label]")
    if (!target) return

    const label = target.getAttribute("data-tooltip-label")
    if (!label) return

    this.tooltip.textContent = label
    this.positionTooltip(target)
    this.tooltip.classList.remove("opacity-0")
    this.tooltip.classList.add("opacity-100")
  }

  hide(event) {
    const related = event.relatedTarget
    if (related && this.element.contains(related)) return

    this.tooltip.classList.remove("opacity-100")
    this.tooltip.classList.add("opacity-0")
  }

  positionTooltip(target) {
    const rect = target.getBoundingClientRect()
    const tooltipWidth = this.tooltip.offsetWidth
    const tooltipHeight = this.tooltip.offsetHeight

    let left = rect.left + rect.width / 2 - tooltipWidth / 2
    let top = rect.top - tooltipHeight - 6

    // Clamp horizontally to viewport
    if (left < 4) left = 4
    if (left + tooltipWidth > window.innerWidth - 4) {
      left = window.innerWidth - tooltipWidth - 4
    }

    // If no room above, show below
    if (top < 4) {
      top = rect.bottom + 6
    }

    this.tooltip.style.left = `${left}px`
    this.tooltip.style.top = `${top}px`
  }
}
